<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import config from '../config/config';
export default {
  name: 'App',
  created () {
    this.$store.dispatch('addmenus')
    // this.$store.dispatch('getMenus')//获取用户菜单
  }
}
</script>

<style lang="scss">
@import "./styles/index.scss"; // 全局自定义的css样式
</style>



// WEBPACK FOOTER //
// src/App.vue